import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiGetMVREnabledProvinces } from 'api';
import { PROVINCE_OPTIONS } from 'variables/options';
import type { SelectOption } from 'components/fields/SelectSearch';

export const useMvrEnabledProvinces = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['mvr-enabled-provinces'],
    queryFn: apiGetMVREnabledProvinces,
    staleTime: 5 * 60 * 1000,
  });

  const provinceOptions = useMemo<SelectOption[]>(() => {
    if (error) return PROVINCE_OPTIONS;
    if (!data) return [];
    return PROVINCE_OPTIONS.filter((opt) => data.provinces.includes(opt.value));
  }, [data, error]);

  return {
    provinceOptions,
    isLoadingProvinces: isLoading,
    provincesError: error,
  };
};
